import { isPatentUrl } from '#pplx/frontend/common/files/urls.js';
const getMetaData = (result) => result?.meta_data;
/**
 * Determines if a result is from a premium (paid/licensed) data source.
 * This includes:
 * - Wiley books (via wiley_book_uuid)
 * - Premium datasources (via is_premium_datasource flag) - e.g. Statista, PitchBook
 */
export function getIsPremiumSource(result) {
    const metaData = getMetaData(result);
    const isWileyBook = typeof metaData?.wiley_book_uuid === 'string' && metaData.wiley_book_uuid !== '';
    const isPremiumDatasource = metaData?.is_premium_datasource === true;
    return isWileyBook || isPremiumDatasource;
}
/**
 * Determines if a result is a patent source, either via an explicit
 * `patent_name` in metadata or a recognizable patent URL.
 */
export function getIsPatentSource(result) {
    const metaData = getMetaData(result);
    return !!metaData?.patent_name || (!!result?.url && isPatentUrl(result.url));
}
//# sourceMappingURL=sourceClassification.js.map